function runPreloader() {
  const ellipse = document.getElementById('holeEllipse');
  const preloader = document.getElementById('preloader');
  let start = null;
  const duration = 1800;
  function step(ts) {
    if (!start) start = ts;
    const t = Math.min((ts - start) / duration, 1);
    const eased = 1 - Math.pow(1 - t, 3);
    const r = eased * 75;
    ellipse.setAttribute('rx', r);
    ellipse.setAttribute('ry', r);
    if (t < 1) { requestAnimationFrame(step); }
    else {
      setTimeout(function() {
        preloader.classList.add('fade-out');
        setTimeout(function() { preloader.classList.add('done'); }, 1900);
      }, 700);
    }
  }
  requestAnimationFrame(step);
}

function initParallax() {
  const heroBg = document.getElementById('heroBg');
  const fullbleedBg = document.getElementById('fullbleedBg');
  function onScroll() {
    const y = window.scrollY || window.pageYOffset;
    if (heroBg) { heroBg.style.transform = 'translateY(' + (y * 0.15) + 'px) scale(1.02)'; }
    if (fullbleedBg) {
      const section = fullbleedBg.closest('.fullbleed');
      const rect = section.getBoundingClientRect();
      const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      const offset = (progress - 0.5) * 100;
      fullbleedBg.style.transform = 'translateY(' + offset + 'px) scale(1.08)';
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

function initFadeIn() {
  const targets = document.querySelectorAll('.statement-text, .showcase-head, .clip-frame, .collection-card, .ritual-step, .ritual-quote, .ritual-image, .ritual-atmos, .journal-card, .footer-photo');
  if (!('IntersectionObserver' in window)) {
    targets.forEach(function(el) { el.classList.add('visible'); });
    return;
  }
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  targets.forEach(function(el) { observer.observe(el); });
}

function initProgressRing() {
  const ring = document.getElementById('progressRing');
  const fill = document.getElementById('progressFill');
  const circumference = 157;
  function onScroll() {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const pct = docHeight > 0 ? Math.min(scrollTop / docHeight, 1) : 0;
    fill.style.strokeDashoffset = circumference - (pct * circumference);
    if (scrollTop > 100) { ring.classList.add('visible'); }
    else { ring.classList.remove('visible'); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}


// ===== Scent tabs =====
// [PROVISIONAL / 仮ノート — 2026-07-01] 下記ノート名は未確定の調香処方の
// イメージ表現。実際の香り決定後、本決定のノートに差し替えること。
function initScentTabs() {
  const tabs = document.querySelectorAll('.scent-tab');
  const topEl = document.getElementById('scentTop');
  const middleEl = document.getElementById('scentMiddle');
  const baseEl = document.getElementById('scentBase');
    const imgEl = document.getElementById('scentImg');
  if (!imgEl || tabs.length === 0) return;

  const data = {
    haze: { top: ['White Tea'], middle: ['Hinoki'], base: ['White Musk'], img: (window.SCENT_IMG && window.SCENT_IMG.haze) || '' },
    still: { top: ['Lavender'], middle: ['Sage'], base: ['Hinoki'], img: (window.SCENT_IMG && window.SCENT_IMG.still) || '' },
    petal: { top: ['Pear'], middle: ['Cardamom Rose'], base: ['White Musk'], img: (window.SCENT_IMG && window.SCENT_IMG.petal) || '' },
    ember: { top: ['Bourbon'], middle: ['Frankincense & Myrrh'], base: ['Vanilla'], img: (window.SCENT_IMG && window.SCENT_IMG.ember) || '' },
    calm: { top: ['Lavender'], middle: ['Hinoki'], base: ['Vanilla', 'White Musk'], img: (window.SCENT_IMG && window.SCENT_IMG.calm) || '' }
  };

  function renderTags(container, items) {
    container.innerHTML = '';
    items.forEach(function(item) {
      const span = document.createElement('span');
      span.className = 'scent-note-tag';
      span.textContent = item;
      container.appendChild(span);
    });
  }

  function activate(key) {
    const d = data[key];
    if (!d) return;
    renderTags(topEl, d.top);
    renderTags(middleEl, d.middle);
    renderTags(baseEl, d.base);
    imgEl.style.opacity = '0';
    setTimeout(function() {
      imgEl.src = d.img;
      imgEl.style.opacity = '1';
    }, 250);
  }

  imgEl.style.transition = 'opacity 0.5s ease';

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      tabs.forEach(function(t) { t.classList.remove('active'); });
      tab.classList.add('active');
      activate(tab.dataset.scent);
    });
  });
}

function initPageTop() {
  const btn = document.getElementById('pageTopBtn');
  if (!btn) return;
  btn.addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

function initContactForm() {
  const btn = document.getElementById('contactSubmitBtn');
  const confirmEl = document.getElementById('contactConfirm');
  if (!btn || !confirmEl) return;
  btn.addEventListener('click', function() {
    const form = btn.closest('.contact-form');
    const name = form.querySelector('input[type="text"]').value.trim();
    const email = form.querySelector('input[type="email"]').value.trim();
    const message = form.querySelector('textarea').value.trim();
    confirmEl.classList.remove('error');
    if (!name || !email || !message) {
      confirmEl.textContent = 'お名前・メールアドレス・本文をご記入ください。';
      confirmEl.classList.add('error', 'visible');
      return;
    }
    confirmEl.textContent = 'メッセージを受け取りました。24時間以内にお返事します。';
    confirmEl.classList.add('visible');
    form.reset();
  });
}

function initAll() {
  runPreloader();
  initParallax();
  initFadeIn();
  initProgressRing();
  initScentTabs();
  initPageTop();
  initContactForm();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}


/* ===================================================
   SHOP CART — EMBER & AURA
   商品をShopifyに登録したら、各 variantId に「バリアントID」(数字) を入れてください。
   例: haze: { price: 4800, variantId: 41234567890123 }
   price は表示用(円)。Shopifyの実価格に合わせて更新してください。
=================================================== */
(function () {
  var SHOP = {
  　 haze:  { price: 8000, variantId: 44237976469622 },
    still: { price: 8000, variantId: 44238008713334 },
    petal: { price: 8000, variantId: 44238123303030 },
    ember: { price: 8000, variantId: 44238126547062 },
    calm:  { price: 8000, variantId: 44238136901750 },
    gift:  { price: 12000, variantId: 44238138736758 },
    obj_tray:      { price: 3000, variantId: null },
    obj_vase:      { price: 2800, variantId: null },
    obj_objet:     { price: 1500, variantId: null },
    obj_container: { price: 2000, variantId: null }
  };
  var yen = function (n) { return '¥' + Number(n).toLocaleString('ja-JP'); };

  document.querySelectorAll('[data-price-key]').forEach(function (el) {
    var k = el.getAttribute('data-price-key');
    if (SHOP[k]) el.textContent = yen(SHOP[k].price);
  });

  var note = function (btn, msg) {
    var sec = btn && btn.closest ? btn.closest('section') : null;
    var n = (sec && sec.querySelector('.cart-note')) || document.getElementById('shopNote');
    if (!n) return;
    n.textContent = msg; n.classList.add('show');
    clearTimeout(n._t); n._t = setTimeout(function () { n.classList.remove('show'); }, 4000);
  };

  document.querySelectorAll('.add-to-cart').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var k = btn.getAttribute('data-key'); var p = SHOP[k];
      if (!p || !p.variantId) { note(btn, 'ただいま準備中です。商品登録後にご購入いただけます。'); return; }
      var orig = btn.textContent; btn.disabled = true; btn.textContent = '追加中…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: p.variantId, quantity: 1 }] })
      }).then(function (r) {
        if (r.ok) { window.location.href = '/cart'; }
        else { note(btn, 'カートに追加できませんでした。'); btn.disabled = false; btn.textContent = orig; }
      }).catch(function () {
        note(btn, '通信エラーが発生しました。'); btn.disabled = false; btn.textContent = orig;
      });
    });
  });
})();


/* ===================================================
   JOURNAL ARTICLE MODAL
=================================================== */
(function () {
  var modal = document.getElementById('articleModal');
  var content = document.getElementById('articleModalContent');
  var store = document.getElementById('journalArticles');
  if (!modal || !content || !store) return;

  function open(key) {
    var art = store.querySelector('article[data-key="' + key + '"]');
    if (!art) return;
    content.innerHTML = art.innerHTML;
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    modal.querySelector('.article-modal-panel').scrollTop = 0;
  }
  function close() {
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('.journal-card[data-article]').forEach(function (card) {
    card.addEventListener('click', function () { open(card.getAttribute('data-article')); });
  });
  modal.querySelectorAll('[data-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('open')) close();
  });
})();
